import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import introduce from '../views/aboutus/introduce.vue'
import campus from '../views/campus.vue'
import society from '../views/society.vue'
import intern from '../views/intern.vue'
import project from '../views/aboutus/project.vue'
import culture from '../views/aboutus/culture.vue'
import life from '../views/aboutus/life.vue'
import recruit from '../views/aboutus/recruit.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import forgetpass from '../views/forgetpass.vue'
import resume from '../views/personal/resume.vue'
import collect from '../views/personal/collect.vue'
import submit from '../views/personal/submit.vue'
import addPosition from '../views/management/addPosition.vue'
import resetPosition from '../views/management/resetPosition.vue'
import lookUpResume from '../views/management/lookUpResume.vue'
import recruitInfoService from '../views/management/recruitInfoService.vue'
import recruitInfo from '../views/recruitInfo.vue'
import arcticList from '../views/management/arcticList.vue'
import recruitInfoList from '../views/recruitInfoList.vue'
import lookUpResumeByName from '../views/management/lookUpResumeByName.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'home',
		component: home,
	},
	// {
	// 	path: '/aboutus/introduce',
	// 	name: 'introduce',
	// 	component: introduce,
	// },
	{
		path: '/campus',
		name: 'campus',
		component: campus,
	},
	{
		path: '/society',
		name: 'society',
		component: society,
	},
	{
		path: '/intern',
		name: 'intern',
		component: intern,
	},
	// {
	// 	path: '/aboutus/project',
	// 	name: 'project',
	// 	component: project,
	// },
	// {
	// 	path: '/aboutus/culture',
	// 	name: 'culture',
	// 	component: culture,
	// },
	// {
	// 	path: '/aboutus/life',
	// 	name: 'life',
	// 	component: life,
	// },
	// {
	// 	path: '/aboutus/recruit',
	// 	name: 'recruit',
	// 	component: recruit,
	// },
	{
		path: '/login',
		name: 'login',
		component: login,
	},
	{
		path: '/register',
		name: 'register',
		component: register,
	},
	{
		path: '/forgetpass',
		name: 'forgetpass',
		component: forgetpass,
	},
	{
		path: '/personal/resume',
		name: 'resume',
		component: resume,
	},
	{
		path: '/personal/collect',
		name: 'collect',
		component: collect,
	},
	{
		path: '/personal/submit',
		name: 'submit',
		component: submit,
	},
	{
		path: '/management/addPosition',
		name: 'addPosition',
		component: addPosition,
	},
	{
		path: '/management/resetPosition',
		name: 'resetPosition',
		component: resetPosition,
	},
	{
		path: '/management/lookUpResume',
		name: 'lookUpResume',
		component: lookUpResume,
	},
	{
		path: '/management/recruitInfoService',
		name: 'recruitInfoService',
		component: recruitInfoService,
	},
	{
		path: '/recruitInfo',
		name: 'recruitInfo',
		component: recruitInfo,
	},
	{
		path: '/management/arcticList',
		name: 'arcticList',
		component: arcticList,
	},
	{
		path: '/recruitInfoList',
		name: 'recruitInfoList',
		component: recruitInfoList,
	},
	{
		path: '/management/lookUpResumeByName',
		name: 'lookUpResumeByName',
		component: lookUpResumeByName,
	},
]

const router = new VueRouter({
	routes
})

export default router
